import { c as _c } from "react/compiler-runtime";
import { SphereDropdownSelector } from "@components/common/dropdown/sphere-dropdown-selector";
import { SphereDropdownButton } from "@components/common/dropdown/sphere-dropdown-button";
import { FontWeights } from "@flat-ui";
import { Box, Grid } from "@mui-wrapper";
import { selectedProjectChartTimeFrameSelector } from "@store/analytics/analytics-selector";
import { setSelectedProjectChartTimeFrame } from "@store/analytics/analytics-slice";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { TIME_FRAMES } from "@utils/time-utils";

/** Renders the controller for the chart in the project overview page */
export function ProjectChartController() {
  const $ = _c(10);
  const dispatch = useAppDispatch();
  const selectedTimeFrame = useAppSelector(selectedProjectChartTimeFrameSelector);
  let t0;
  if ($[0] !== dispatch) {
    t0 = function handleTimeFrameChange(value) {
      dispatch(setSelectedProjectChartTimeFrame(value));
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleTimeFrameChange = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-between",
      marginBottom: "24px"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Grid sx={{
      alignItems: "center",
      display: "flex",
      color: "text.primary",
      fontSize: "14px",
      fontWeight: FontWeights.Bold,
      lineHeight: "20px"
    }}>Total 360° images</Grid>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      alignItems: "center",
      height: "100%"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box sx={{
      fontWeight: FontWeights.Bold,
      marginRight: "10px"
    }}>Date Range:</Box>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handleTimeFrameChange || $[8] !== selectedTimeFrame) {
    t6 = <Grid container={true} sx={t1}>{t2}<Grid><Box sx={t3}>{t4}<SphereDropdownSelector items={TIME_FRAMES} currentValue={selectedTimeFrame} handleChange={handleTimeFrameChange} menuPosition={t5} renderButton={_temp} /></Box></Grid></Grid>;
    $[7] = handleTimeFrameChange;
    $[8] = selectedTimeFrame;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(props) {
  return <SphereDropdownButton {...props} />;
}